module.exports = __webpack_public_path__ + "img/modern_shop_thumbnail.10e226ca.jpg";